import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DemoLauncher() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/public/demo-login`);
        localStorage.setItem('ctc_supplier_token', data.token);
        if (data.site_access) localStorage.setItem('ctc_site_access', data.site_access);
        sessionStorage.setItem('ctc_demo', '1');
        sessionStorage.setItem('ctc_demo_tour', 'public');
        navigate('/suppliers/care-tech-demo-co', { replace: true });
      } catch (e) {
        setError('Could not start the demo. Please make sure the demo account is set up.');
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B2942] text-white" data-testid="demo-launcher">
      {error ? (
        <div className="text-center max-w-md px-6">
          <p className="text-lg font-semibold mb-2">Demo unavailable</p>
          <p className="text-white/70 text-sm">{error}</p>
        </div>
      ) : (
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-[#00A79D]" />
          <p className="text-lg font-semibold">Launching the Care Tech Compare demo…</p>
          <p className="text-white/60 text-sm mt-1">Signing you in as a demo tech supplier.</p>
        </div>
      )}
    </div>
  );
}
